import { KendoBaseComponent, KendoBaseDatasourceComponent } from '@progress/kendo-base-components-vue-wrapper'
import SpreadsheetProps from './SpreadsheetProps'
import KendoSpreadsheetSheet from '../KendoSpreadsheetSheet'

import DefaultCellStyle from './DefaultCellStyle'
import Excel from './Excel'
import Pdf from './Pdf'
import Toolbar from './Toolbar'

export default {
    props: SpreadsheetProps,
    emits: {
        'kendowidgetready': null
    },
    mixins: [
        KendoBaseComponent,
        KendoBaseDatasourceComponent,
        DefaultCellStyle,
        Excel,
        Pdf,
        Toolbar
    ],
    mounted() {
        this._resolveChildren()

        kendo.jQuery(this.$el).kendoSpreadsheet(this.widgetOptions)

        if(this.v3) {
            this.ready()
            this.$emit('kendowidgetready', this.kendoWidget())
        } else {
            this.$emit('kendowidgetready', this.kendoWidget())
        }
    },
    methods: {
        kendoWidget() {
            return kendo.jQuery(this.$el).getKendoSpreadsheet()
        },
        _resolveChildren() {
            this.resolveChildren('sheets', KendoSpreadsheetSheet.name)
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-spreadsheet-vue-wrapper/src/KendoSpreadsheet/KendoSpreadsheetMixin.js